<template>
  <div class="navbar">
    <h1 class="logo">My Map App</h1>
    <nav class="nav-links">
      <router-link to="/" class="nav-link">Home</router-link>
      <router-link to="/database" class="nav-link">Database</router-link>
      <a href="https://avinor.rfid-solutions.no" class="nav-link" target="_blank">Dashboard</a>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.navbar {
  background-color: #333;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
}

.logo {
  margin: 0;
  font-size: 24px;
}

.nav-links {
  display: flex;
}

.nav-link {
  text-decoration: none;
  color: white;
  padding: 10px;
}

.nav-link:hover {
  background-color: #555;
  border-radius: 5px;
}
</style>
